import type { GetCustomRolesResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetCustomRolesQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetCustomRolesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetCustomRoles = createQueryHook<
  Record<string, never>,
  GetCustomRolesResponseRow[],
  GetCustomRolesQuery
>({
  trpcQueryOptions: (trpc) => trpc.frontend.role.getCustomRoles.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({
    custom_role: data.map((role) => ({
      ...role,
      customRoleUsers_aggregate: {
        aggregate: { count: role.customRoleUsers?.length ?? 0 },
      },
    })),
  }),
  graphqlDocument: GetCustomRolesDocument,
});
